"use client";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useState } from "react";
import { useRouter } from "next/navigation";
import Link from "next/link";

export default function PortalDoClientePage() {
  const [modal, setModal] = useState(false);
  const [cpf, setCpf] = useState("");
  const [loading, setLoading] = useState(false);
  const router = useRouter();

  const handleDocumentsClick = () => {
    setModal(true);
  };

  const formatDocumento = (value: string) => {
    const numbers = value.replace(/\D/g, "");

    // CPF — 11 digits
    if (numbers.length <= 11) {
      return numbers
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    }

    // CNPJ — 14 digits
    return numbers
      .replace(/(\d{2})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1/$2")
      .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
  };

  const getDocumentType = (clean: string) => {
    if (clean.length <= 11) return "CPF";
    return "CNPJ";
  };

  const handleDocumentoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatDocumento(e.target.value);
    setCpf(formatted);
  };

  const handleSubmit = async () => {
    if (!cpf.trim()) {
      alert("Por favor, digite um CPF ou CNPJ");
      return;
    }

    const clean = cpf.replace(/\D/g, "");
    const tipo = getDocumentType(clean);

    // CORRECTION: CNPJ is 14 digits, not 13
    const expectedLength = tipo === "CPF" ? 11 : 14;

    if (clean.length !== expectedLength) {
      console.log(clean);
      alert(`Por favor, digite um ${tipo} válido`);
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`/api/login/${clean}`);
      const data = await response.json();

      if (response.ok && data.exists) {
        router.push(`/documentos/${clean}`);
      } else if (response.ok && !data.exists) {
        alert(`${tipo} não encontrado. Verifique os dados e tente novamente.`);
      } else {
        alert(data.error || "Erro ao validar documento");
      }
    } catch (error) {
      console.error("Error validating document:", error);
      alert("Erro ao conectar com o servidor. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setModal(false);
    setCpf("");
  };

  return (
    // Added p-4 to prevent content from touching edges on very small screens
    <main
      className="min-h-screen flex flex-col items-center justify-center p-4"
      style={{
        backgroundImage: `url(https://image.crm.costao.com.br/lib/fe3611747364047c761072/m/1/1314f3e6-e8df-486b-9532-01cfb928b796.jpeg)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      {modal && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
          <div className="bg-white p-6 md:p-8 rounded-lg shadow-lg max-w-md w-full">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold">Portal do Cliente</h2>
              <button
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-700 text-3xl font-bold px-2"
                disabled={loading}
              >
                ×
              </button>
            </div>
            <p className="text-gray-600 mb-4 font-[montserrat]">
              Digite seu CPF/CNPJ para acessar documentos:
            </p>
            <Input
              type="text"
              value={cpf}
              onChange={handleDocumentoChange}
              placeholder="CPF ou CNPJ"
              className="mb-4 w-full"
              maxLength={18}
              onKeyPress={(e) => e.key === "Enter" && handleSubmit()}
              disabled={loading}
            />
            <div className="flex flex-col sm:flex-row gap-2">
              <Button
                variant="outline"
                className="w-full sm:w-auto"
                onClick={closeModal}
                disabled={loading}
              >
                Cancelar
              </Button>
              <Button
                variant="secondary"
                className="flex-1 w-full"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? "Validando..." : "Acessar Portal"}
              </Button>
              
            </div>
          </div>
        </div>
      )}

              <div className="font-bold bg-primary/90 rounded-3xl flex flex-col md:flex-col justify-between items-center gap-10 p-8 md:p-18 lg:p-18 w-full max-w-6xl">
          <h1 className="text-white text-3xl md:text-4xl text-center">
            Portal do Cliente
          </h1>
          <div className="flex flex-col md:flex-row justify-center w-full gap-8 md:gap-4">
            <div className="flex flex-col text-white w-full md:w-5/12 text-center">
              <Button variant="secondary" asChild className="text-white border border-neutral-400 text-lg py-6 w-full">
                <Link href={"https://esolution.costao.com.br/LoginCentralCliente"}>
                  Financeiro
                </Link>
              </Button>
              <p className="mt-2 text-sm md:text-base font-[montserrat]">Para solicitações e acompanhamento da sua fração.</p>
            </div>

            <div className="flex flex-col text-white w-full md:w-5/12 text-center">
              <Button
                onClick={handleDocumentsClick}
                variant="outline"
                className="text-xl py-6 border border-neutral-400 text-primary w-full"
              >
                Documentações
              </Button>
              <p className="mt-2 text-sm md:text-base font-[montserrat]">Acesse documentos importantes da sua fração.</p>
            </div>
          </div>
        </div>
    </main>
  );
}
